"use client";

import { WrenchIcon } from "lucide-react";

import type { DisplayMessage } from "../../types";
import { extractText, truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";
import { ContentBlocks } from "../ContentBlocks";

interface ToolResponseSectionProps {
  message: DisplayMessage;
}

export const ToolResponseSection = ({ message }: ToolResponseSectionProps) => {
  const label = message.name || "Tool Response";
  const text = extractText(message.content);
  const preview = truncate(text);

  return (
    <CollapsibleSection
      icon={<WrenchIcon className="h-3 w-3 text-amber-600" />}
      label={label}
      preview={preview}
      copyContent={text}
    >
      <div className="rounded-md bg-amber-50/50 p-2">
        <ContentBlocks content={message.content} />
      </div>
    </CollapsibleSection>
  );
};
